<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="机构名称" prop="insId">
            <el-select v-model="rule.insId">
                <el-option value="" label="请选择"></el-option>
                <el-option v-for="x in selectList" :key="x.id" :value="x.id" :label="x.name"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                rule:{
                    customerId: null,
                    insId:'',
                },
                rules: {
                    insId: { required: true, message: '请选择机构' },
                },
                selectList:[],
            }
        },
        async created() {
            if(this.$route.params.id) {
                this.rule.customerId = this.$route.params.id;
                await this.$http.post('/manage/institution/listAll').then(data => {
                    this.selectList = data['data']['data'];
                }).catch(() => {
                    this.$router.push('/customer/index');
                });
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        this.$http.post('/manage/customer/bindIns',this.rule).then(() => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/customer/index');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            block() {
                this.$router.push('/customer/index');
            },
        }
    }
</script>